export default "__VITE_ASSET__CZbH0eoK__"